import React from 'react';
import './Privacy.css';

const Privacy = () => {
    return (
        <div className='privacy-layer'>
            <h5> سیاست‌نامه حریم خصوصی</h5>
            <h6>
                مقدمه:
            </h6>
            <p>
                البرز مارکت همواره حریم خصوصی کاربران خود را محترم می‌شمارد و به حفاظت از اطلاعات شخصی‌ای که به آن سپرده می‌شود متعهد است.
                البرز مارکت  در صورت دریافت دستور قضایی و در حدود قوانین، اطلاعات کاربران خود را در اختیار مقام قضایی قرار می‌دهد. استفاده از البرز مارکت بیانگر موافقت شما با این سند بوده و مطالعه آن جهت آگاهی از سیاست‌های البرز مارکت درباره جمع‌آوری اطلاعات کاربران ضروری است.

            </p>
            <h6>
                اطلاعاتی که از کاربر جمع‌آوری می‌گردد:
            </h6>
            <h6>
                اطلاعات مربوط به حساب کاربری:
            </h6>
            <p>
                شما به محض ثبت نام در سایت یا اپلیکیشن البرز مارکت از طریق  شماره‌ی تلفن همراه خود، صراحتاً موافقت خود را با ذخیره‌سازی قانونی اطلاعات شخصی خود و استفاده و محافظت البرز مارکت از این اطلاعات، اعلام می‌دارید. شماره تلفن همراه شما برای احراز هویت و اعتبار سنجی شما در اپلیکیشن استفاده خواهد شد.
                اطلاعات مربوط به استفاده از البرز مارکت:
                همه‌ی افراد می‌توانند بدون ثبت نام به اپلیکیشن البرز مارکت مراجعه کنند. هر گونه فعالیت شما پس از اعتبار سنجی حساب کاربری در اپلیکیشن فقط جهت ثبت لیست کالاهای مورد نیاز مشتریان برای تحویل حضوری خواهد بود.

            </p>
            <h6>
                اطلاعات شخصی شما در اختیار چه اشخاصی قرار می گیرند؟
            </h6>
            <p>
                البرز مارکت اطلاعات حساب کاربری و لیست کالاهای ثبت شده توسط کاربران را در اختیار کارمندان گروه صنعتی بازرگانی البرز قرارداده تا در صورت تأیید ، بسته بندی و آماده تحویل حضوری به کاربران نمایند.
            </p>

            <h6>
                امنیت داده:
            </h6>
            <p>
                حفاظت از اطلاعات حساب کاربران و جلوگیری از دسترسی‌های غیرمجاز به این اطلاعات، یکی از اولویت‌های اصلی البرز مارکت است. بر همین اساس:

                برای هر بار ورود به حساب کاربری در البرز مارکت از رمز عبور یک‌بار مصرف (OTP) استفاده می‌شود که تنها با دسترسی به شماره تلفن همراهی که از طریق آن در البرز مارکت، حساب کاربری خود را ایجاد کرده‌اید امکان‌پذیر است.
            </p>
        </div>
    );
}

export default Privacy;